
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryShortDto = MdbsCore.IQueryShortDto;
import QueriesCountIcon from "@/components/query/icons/QueriesCountIcon.vue";
import IQueryAnswerDto = MdbsCore.IQueryAnswerDto;
import {queryModule} from "@/store";
import IQueryAcceptDto = MdbsCore.IQueryAcceptDto;
import IQueryRevokeDto = MdbsCore.IQueryRevokeDto;
import IQuerySolveDto = MdbsCore.IQuerySolveDto;
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import QueryAnswerDialog from "@/components/query/dialogs/QueryAnswerDialog.vue";
import QueryAnswerMenuItem from "@/components/query/menu/QueryAnswerMenuItem.vue";
import IQueryEditDto = MdbsCore.IQueryEditDto;
import IQueryDto = MdbsCore.IQueryDto;
import IQueryDeferDto = MdbsCore.IQueryDeferDto;

@Component({
  name: 'QueryOverviewTableAnswer',
  components: {QueriesCountIcon, QueryAnswerMenuItem, QueryAnswerDialog},
})
export default class QueryOverviewTableAnswer extends Vue {

  @Prop({required: true})
  private query: IQueryDto;
  @Prop({required: true})
  private queryTypeDefinition: QueryTypeDefinitionDto;
  @Prop({required: true})
  private referenceId: string;
  @Prop({required: true})
  private referenceType: string;

  showAnswerQuery = false;
  selectedQuery: IQueryShortDto | null = null;

  handleAnswerQuery() {
    this.showAnswerQuery = true;
  }

  async handleEditQuery(queryEdit: IQueryEditDto) {
    await queryModule.editQuery(queryEdit);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  async handleSaveAnswerQuery(queryAnswer: IQueryAnswerDto) {
    await queryModule.answerQuery(queryAnswer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  async handleRevokeAnswerQuery(queryRevoke: IQueryRevokeDto) {
    await queryModule.revokeQuery(queryRevoke);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  async handleAcceptAnswerQuery(queryAccept: IQueryAcceptDto) {
    await queryModule.acceptQuery(queryAccept);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  async handleSolveAnswerQuery(querySolve: IQuerySolveDto) {
    await queryModule.solveQuery(querySolve);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  async handleDeferAnswerQuery(queryDefer: IQueryDeferDto) {
    await queryModule.deferQuery(queryDefer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
    await this.reload();
  }

  @Emit("reload-query-overview")
  async reload() {
  }
}
